import React from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import InfiniteScroll from "react-infinite-scroller";
import { Tooltip } from "antd";
import { FormattedMessage, injectIntl } from "react-intl";
import { arrayMonths } from "../../../constants/shortMonthString";
import { getIconByType } from "../../../libs/documentsUtils";

let excludedCategories = ["Fatture emesse", "Fatture ricevute"];

function buildFilename(item) {
  let periodoRif = null;
  let nomeFile = null;
  if (item.infoList) {
    item.infoList.map(info => {
      periodoRif = info.label === "Periodo riferimento" ? info.value : null;
      return null;
    });
  }
  return (
    <span>
      {nomeFile || item.title || ""}
      {periodoRif ? " " + periodoRif : ""}
    </span>
  );
}

function renderDocumentsList(
  nextProps, prevState, clearDocs
) {
  const {
    addDocument,
    documentsWithSearch,
    previewDocument,
    selected,
    currentDocumentId
  } = nextProps;
  let prevDocumentsIds = clearDocs ? [] : prevState.prevDocumentsIds;
  let documents = clearDocs ? [] : prevState.prevDocuments;
  const list = documentsWithSearch.results.list;
  let documentsWithSearchFiltered;
  if (list !== null) {
    documentsWithSearchFiltered = list?.filter(doc => {
      return currentDocumentId !== doc.documentId;
    });
  }
  if (documentsWithSearchFiltered !== undefined) {
    if (documentsWithSearchFiltered && !clearDocs) {
      documentsWithSearchFiltered.map(item => {
        if (
          prevDocumentsIds.indexOf(item.documentId) === -1 &&
          excludedCategories.indexOf(item.title) === -1
        ) {
          let filename = item.fileName || buildFilename(item);
          let dataUpload = item.infoList.filter(a => a.label === "Data caricamento");
          const dataArray = dataUpload[0].value.split("/");
          const stringMonth = arrayMonths[dataArray[1]];
          const dataDoc = dataArray[0] + " " + stringMonth + " " + dataArray[2];
          documents.push(<div
            className={
              selected[item.documentId]
                ? "addDocument-tooltip-document selected"
                : "addDocument-tooltip-document"
            }
            key={`addDocument-document_${item.documentId}`}
          >
            <span className="addDocument-tooltip-document-text">
              <div className="fileName">{filename}</div>
              {dataUpload.length > 0 ? (
                <div className="addDocument-tooltip-document-date">
                  <span>
                    <FormattedMessage id="widgets.documentBrowsing.info.date" />{" "}
                    {dataDoc}
                  </span>
                </div>
              ) : (
                ""
              )}
            </span>
            <FontAwesomeIcon
              className="addDocument-icon-eye"
              icon={["fas", "eye"]}
              style={{ fontSize: 14 }}
              onClick={() => previewDocument(item.documentId)}
            />
            {!selected[item.documentId] && (
              <Tooltip
                color={"rgb(0, 80, 117)"}
                getPopupContainer={trigger => trigger.parentNode}
                overlayClassName="addDocument-not-allowed-tooltip"
                title={
                  item.visibleByStudioOnly
                    ? "Documento non allegabile in quanto visible solo allo studio"
                    : ""
                }
              >
                <FontAwesomeIcon
                  className={
                    "addDocument-icon-plus" +
                      (item.visibleByStudioOnly ? " disabled" : "")
                  }
                  icon={["fas", "plus"]}
                  style={{ fontSize: 14 }}
                  onClick={e => {
                    if (!item.visibleByStudioOnly) {
                      if (e.target.nodeName === "svg") {
                        e.target.parentNode.classList.add("selected");
                      } else {
                        e.target.parentNode.parentNode.classList.add("selected");
                      }
                      addDocument({
                        documentId: item.documentId,
                        filename: filename
                      });
                    }
                  }}
                />
              </Tooltip>
            )}
          </div>);
        }
        return null;
      });
    }
  }

  return documents;
}

function getDocumentsIds(
  nextProps, prevState, clearDocs
) {
  const { documentsWithSearch } = nextProps;
  let docIds = clearDocs ? [] : prevState.prevDocumentsIds;
  if (documentsWithSearch.results !== undefined) {
    if (documentsWithSearch.results.list && !clearDocs) {
      documentsWithSearch.results.list.map(item => {
        if (
          docIds.indexOf(item.documentId) === -1 &&
          excludedCategories.indexOf(item.title) === -1
        ) {
          docIds.push(item.documentId);
        }
        return null;
      });
    }
  }
  return docIds;
}

class DocumentsCategoryBrowsing extends React.PureComponent {
  constructor() {
    super();
    this.state = {
      prevDocuments: [],
      prevDocumentsIds: [],
      searchValue: ""
    };
  }

  loadMoreItems() {
    const { documentsWithSearch } = this.props;
    if (
      documentsWithSearch.links &&
      !documentsWithSearch.isGettingDocumentsWithSearch &&
      this.state.prevDocuments.length > 0
    ) {
      this.props.loadDocuments(this.props.documentBrowsingCategory,
        documentsWithSearch.links.href);
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    return {
      searchValue: nextProps.searchValue,
      prevDocuments:
        nextProps.documentBrowsingPage === 1 && nextProps.searchValue.length < 3
          ? prevState.prevDocuments
          : renderDocumentsList(
            nextProps,
            prevState,
            nextProps.searchValue !== prevState.searchValue
          ),
      prevDocumentsIds:
        prevState.documentBrowsingPage === 1 && nextProps.searchValue.length < 3
          ? prevState.prevDocumentsIds
          : getDocumentsIds(
            nextProps,
            prevState,
            nextProps.searchValue !== prevState.searchValue
          )
    };
  }

  checkCategory(label) {
    let value = false;
    excludedCategories.map(item => {
      if (label.indexOf(item) > -1) {
        value = true;
      }
      return null;
    });
    return value;
  }

  renderCategories() {
    const { searchValue, documentsTypes } = this.props;
    let items = [];
    let filterIndex = -1;
    let idx = -1;
    if (this.props.documentsWithSearch.filters === undefined) {
      return null;
    }
    this.props.documentsWithSearch.filters.list.map(it => {
      idx++;
      if (it.title === "Tipo documento") {
        filterIndex = idx;
      }
      return null;
    });
    let cn = 0;
    if (
      this.props.documentsWithSearch.filters.list &&
      this.props.documentsWithSearch.filters.list.length > 0 &&
      filterIndex > -1
    ) {
      this.props.documentsWithSearch.filters.list[filterIndex].links.map(item => {
        cn++;
        if (
          (!searchValue ||
              item.label.toLowerCase().indexOf(searchValue.toLowerCase()) >
                -1) &&
            !this.checkCategory(item.label)
        ) {
          return items.push(<div
            key={`addDocument_category_${cn}`}
            className="addDocument-tooltip-category catAdd"
            onClick={() => {
              this.setState({
                prevDocuments: [],
                prevDocumentsIds: []
              });
              this.props.loadDocuments(
                item.label, null, true
              );
              this.props.onChangeBrowsingPage(2);
            }}
          >
            <FontAwesomeIcon
              className="addDocument-icon-folder"
              icon={["far", getIconByType(item.label, documentsTypes)]}
              style={{ fontSize: 16 }}
            />
            <span style={{ display: "flex", marginLeft: "15px" }}>
              <div className="folderName">{
                item.label === "Non specificato"
                  ? <FormattedMessage id="folders.docCategories.unSpecified" />
                  : item.label}</div>
              <div className="addDocument-tooltip-category-count">
                {item.count}{" "}
                <FormattedMessage id="widgets.documentBrowsing.info.documents" />
              </div>
            </span>
          </div>);
        }
        return null;
      });
    }
    return (
      <div>
        <div className="addDocument-tooltip-title filesAdd">
          <FormattedMessage id="widgets.documentBrowsing.title" />
        </div>
        <div className="addDocument-tooltip-categories">{items}</div>
      </div>
    );
  }

  renderDocuments() {
    const { documentsWithSearch,intl } = this.props;
    let hasMore =
      documentsWithSearch.links && documentsWithSearch.links.href
        ? true
        : false;
    let documents = this.state.prevDocuments;
    return (
      <div>
        <div className="addDocument-tooltip-title documentsAdd">
          <FontAwesomeIcon
            className="addDocument-icon-back"
            icon={["fas", "arrow-left"]}
            onClick={() => {
              this.setState({
                prevDocuments: [],
                prevDocumentsIds: []
              });
              this.props.onBack();
              this.props.resetDocuments();
              this.props.onChangeBrowsingPage(1);
            }}
          />{" "}
          {this.props.documentBrowsingCategory !== ""
            ? this.props.documentBrowsingCategory === "Non specificato" 
              ? intl.formatMessage({id:"folders.docCategories.unSpecified"})
              : this.props.documentBrowsingCategory
            : "Tutti"}
        </div>
        <div className="addDocument-tooltip-documents">
          <InfiniteScroll
            initialLoad={false}
            loadMore={this.loadMoreItems.bind(this)}
            hasMore={hasMore}
            loader={null}
            pageStart={0}
            useWindow={false}
          >
            {documents.length > 0 &&
            !documentsWithSearch.isGettingDocumentsWithSearch ? (
                documents
              ) : documentsWithSearch.isGettingDocumentsWithSearch ? (
                ""
              ) : (
                <span>
                  <FormattedMessage id="widgets.documentBrowsing.info.noDocuments" />
                </span>
              )}
            {documentsWithSearch.isGettingDocumentsWithSearch && (
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  margin: "auto",
                  paddingTop: 10
                }}
              >
                <div style={{ flex: "0 0 auto", margin: "auto" }}>
                  <FontAwesomeIcon
                    icon={["far", "circle-notch"]}
                    style={{ fontSize: "22px", color: "#0090d1" }}
                    spin
                  />
                </div>
              </div>
            )}
          </InfiniteScroll>
        </div>
      </div>
    );
  }

  render() {
    const { documentsWithSearch } = this.props;
    const loader = (
      <div
        style={{
          display: "flex",
          width: "100%",
          margin: "auto",
          paddingTop: 10
        }}
      >
        <div style={{ flex: "0 0 auto", margin: "auto" }}>
          <FontAwesomeIcon
            icon={["far", "circle-notch"]}
            style={{ fontSize: "22px", color: "#0090d1" }}
            spin
          />
        </div>
      </div>
    );
    if (this.props.documentBrowsingPage === 1) {
      if (documentsWithSearch.isGettingDocumentsWithSearch) {
        return loader;
      }
      return this.renderCategories();
    }
    return this.renderDocuments();
  }
}

function mapStateToProps(state) {
  return {
    documentsTypes: state.documents.classification.typesDocuments,
    documentsWithSearch: state.documentsWithSearch
  };
}

export default injectIntl(connect(mapStateToProps, null)(DocumentsCategoryBrowsing));
